import { useState } from 'react';

// Captures the browser's geolocation as { lat, lng } for delivery-address
// coordinates. Used as a quick-fill shortcut alongside the map picker
// (LocationPickerMap), which lets the customer pin a different location.
const useCurrentLocation = () => {
  const [locating, setLocating] = useState(false);
  const [locationError, setLocationError] = useState(null);

  const captureLocation = () =>
    new Promise((resolve) => {
      if (!navigator.geolocation) {
        setLocationError('Location services are not available in this browser.');
        resolve(null);
        return;
      }
      setLocating(true);
      setLocationError(null);
      navigator.geolocation.getCurrentPosition(
        (position) => {
          setLocating(false);
          resolve({ lat: position.coords.latitude, lng: position.coords.longitude });
        },
        () => {
          setLocating(false);
          setLocationError('Could not get your location. Please allow location access and try again.');
          resolve(null);
        },
        { enableHighAccuracy: true, timeout: 10000 }
      );
    });

  return { locating, locationError, captureLocation };
};

export default useCurrentLocation;
